module.exports = __webpack_public_path__ + "static/media/Explosion_002_Tile_8x8_256x256.d28fc70f.png";